/* eslint-disable consistent-return */
import { notification } from 'antd'
import apiClient from '../index'

export const uploadManualPayroll = async (file) => {
  try {
    const formData = new FormData()
    formData.append('file', file)

    return await apiClient.post('employee/addMannulPayrollData', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message || 'Failed to upload payroll data',
      })

      // Return detailed error information if available
      if (error.response.data.errors) {
        return {
          error: true,
          message: error.response.data.message,
          errors: error.response.data.errors,
        }
      }
    } else {
      notification.error({
        message: 'Error',
        description: 'An unexpected error occurred while uploading payroll data',
      })
    }

    throw error
  }
}

export const getEmpPayroll = async (params) => {
  const { skip, limit, locationId, empName, month, year } = params
  try {
    return await apiClient.get(`employee/emp-payroll`, {
      params: {
        skip,
        limit,
        locationId,
        empName,
        month,
        year,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const getpayrollData = async (userId, month, year) => {
  try {
    return await apiClient.get(`employee/emp-payroll/${userId}`, {
      params: { month, year },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const updatePayroll = async (id, payrollData) => {
  try {
    return await apiClient.put(`employee/payroll/${id}`, payrollData) // Send the payrollData to the API
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
    throw error // Ensure the error is thrown to be caught by the calling function
  }
}

export const getListOfEmployeeWithPayroll = async (params) => {
  const { skip, limit, month, year, employeeName, locationId, depId, userProcess } = params
  try {
    return await apiClient.get(`employee/getUsersWithPayroll`, {
      params: {
        skip,
        limit,
        month,
        year,
        employeeName,
        locationId,
        depId,
        userProcess,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const getListOfEmployeeWithPayrollData = async (params) => {
  const { month, year, employeeName, locationId, depId, userProcess } = params
  try {
    return await apiClient.get(`employee/getUsersWithPayrollData`, {
      params: {
        month,
        year,
        employeeName,
        locationId,
        depId,
        userProcess,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const sharePayrollByMonthYear = async (body) => {
  const { month, year } = body

  try {
    const monthString = String(month).padStart(2, '0')

    return await apiClient.post('employee/sharePayrollByMonthYear', {
      month: monthString,
      year,
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
